import React, { useState } from "react";
import {
  Avatar, Box, Button, Menu, MenuItem, Typography,
} from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";

type AccountDataProps = {
  accountName: string,
  handleShowJUSAccounts: (event: React.MouseEvent<HTMLLIElement>) => void,
  handleChangeJUSAccount: (event: React.MouseEvent<HTMLLIElement>) => void,
  pathname?: string,
}
function AccountData({
  accountName, handleShowJUSAccounts, handleChangeJUSAccount, pathname = "/",
}: AccountDataProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Avatar>{accountName.charAt(0)}</Avatar>
      <Box ml={2}>
        <Typography>Current account: </Typography>
        <Typography>{accountName}</Typography>
      </Box>
      <Button onClick={handleClick}>
        <ArrowDropDown sx={{ color: "#fff" }} />
      </Button>
      <Menu
        open={open}
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        anchorEl={anchorEl}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={handleClose}
      >
        <MenuItem onClick={handleShowJUSAccounts} disableRipple>
          { pathname === "/" ? "Show list of JUS accounts" : "To main page" }
        </MenuItem>
        <MenuItem onClick={handleChangeJUSAccount} disableRipple>
          Change Jus account
        </MenuItem>
      </Menu>
    </>
  );
}

export default AccountData;
